import { render, staticRenderFns } from "./SupplierApp.vue?vue&type=template&id=fe5b6e7a&scoped=true"
import script from "./SupplierApp.vue?vue&type=script&lang=js"
export * from "./SupplierApp.vue?vue&type=script&lang=js"
import style0 from "./SupplierApp.vue?vue&type=style&index=0&id=fe5b6e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5b6e7a",
  null
  
)

export default component.exports